import styled from 'styled-components';

const ShopifyErrorPage = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const FlexContent = styled.div`
  margin: auto;
  padding: 4rem 4rem 25rem 4rem;
`;

const TopImage = styled.img`
  margin-top: 2.5rem;
  width: 5rem;
`;

const TitleLabel = styled.p`
  color: #001758;
  font-family: 'Lato-Light', sans-serif;
  font-size: 2.5rem;
  font-weight: 300;
  line-height: 3.1rem;
  margin-bottom: 2.5rem;
  margin-top: 2.5rem;
`;

const DescriptionLabel = styled.p`
  color: #7f7f7f;
  font-family: 'Lato-Light', sans-serif;
  font-size: 1.4rem;
  font-weight: 300;
  line-height: 1.8rem;
  margin-bottom: 2.5rem;
`;

const BackButton = styled.button`
  background-color: #44b1df;
  border: 0 solid #787878;
  border-radius: 2.2rem;
  color: #ffffff;
  font-family: lato, sans-serif;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.5rem;
  margin-bottom: 2.5rem;
`;

export { ShopifyErrorPage, FlexContent, TopImage, TitleLabel, DescriptionLabel, BackButton };
